(function (factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        var v = factory(require, exports);
        if (v !== undefined) module.exports = v;
    }
    else if (typeof define === "function" && define.amd) {
        define('score_ccf/Utils/global',["require", "exports"], factory);
    }
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var globalNs = (function () {
        // the only reliable means to get the global object is
        // `Function('return this')()`
        // However, this causes CSP violations in Chrome apps.
        if (self !== void 0) {
            return self;
        }
        if (window !== void 0) {
            return window;
        }
        throw new Error('Unable to get  global object');
    })();
    exports.default = globalNs;
});
//# sourceMappingURL=global.js.map;
